import { useEffect } from "react";
import { useSubCategory } from "../../../../store/subCategory";
import { getMessageInError } from "../../../../hooks/fetch";
import { message } from "antd";
import { useDispatch } from "react-redux";
import {
    subCategoryById,
    subCategoryByIdClear,
    subCategoryByIdErrorClear,
    SubCategoryByIdParams,
} from "../../../../store/subCategory/byId";
import { Action } from "redux-saga";

export const useSubCategoryById = () => {
    const dispatch = useDispatch();
    const { byId } = useSubCategory()

    const getSubCategoryById = (params: SubCategoryByIdParams) => {
        dispatch(subCategoryById(params) as Action)
    }

    useEffect(() => () => {
        dispatch(subCategoryByIdClear() as Action)
        dispatch(subCategoryByIdErrorClear() as Action)
    }, [])

    useEffect(() => {
        if (byId.error) {
            message
                .error(getMessageInError(byId.error))
                .then(() => dispatch(subCategoryByIdErrorClear() as Action));
        }
    }, [byId.error])

    const clearSubCategoryById = () => {
        dispatch(subCategoryByIdClear() as Action)
        dispatch(subCategoryByIdErrorClear() as Action)
    }

    return { getSubCategoryById, clearSubCategoryById, response: byId.response, error: byId.error, loading: byId.loading };
}
